import React from 'react'
import './TopServices.scss'
import RoundText2 from './RoundText2'
import Kafel from './Kafel'
import DecoIco1 from '../Images/decoIco1.svg'
import DecoIco2 from '../Images/decoIco2.svg'
import DecoIco3 from '../Images/decoIco3.svg'
import DecoIco4 from '../Images/decoIco4.svg'
import DecoIco5 from '../Images/decoIco5.svg'


function TopServices() {

    return (
        <div className='top-services-main full-width'>
            <div className='title-section main-grid'>
                <div className='col-one'>

                    <h3 className='unbounded-font'>
                        BLUE  COAST STUDIO
                    </h3>

                </div>
                <div className='col-two'>
                    <p className='inter-font'>
                        services made to assist<br />
                        the growth and development.
                    </p>

                </div>
                <div className='col-three'>

                    <RoundText2
                        height='109px'
                        arrwidth='30px'
                    />

                </div>

            </div>
            <div className='kafle-section main-grid'>
                <div className='kafel-1'>
                    <Kafel
                        ico={DecoIco1}
                        title='Premium Design'
                        description='Give your users a website, mobile app, or any other digital experience that is easy to use, and looks great with UX/UI services we offer.'
                    />
                </div>
                <div className='kafel-2'>
                    <Kafel
                        ico={DecoIco2}
                        title='Consulting'
                        description='Powering it all is a personalised, battle-tested process we never stray from. It’s how we guarantee exceptional results – every single time.'
                    />
                </div>
                <div className='kafel-3'>
                    <Kafel
                        ico={DecoIco3}
                        title='Advertising'
                        description='The best part about Google ads is that you can quickly get started without spending too much money on advertisements.'
                    />
                </div>
                <div className='kafel-4'>
                    <Kafel
                        ico={DecoIco4}
                        title='Growth'
                        description='It can be challenging for businesses to stand out from the crowd – but not if they know how to use Ads properly.'
                    />
                </div>
                <div className='kafel-5'>
                    <Kafel
                        ico={DecoIco5}
                        title='Beyond'
                        description='Are you an ambitious brand that wants to create world-class products? When the stakes are high and the scale is great, V8 is ideal partner for you.'

                    />
                </div>

            </div>


        </div>
    )
}

export default TopServices